import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { setIsOpenListPanel } from "app/pages/sales-intelligence/modules/leads-search";
import type { SiAdvancedSearchPageParams } from "app/pages/sales-intelligence/services/navigation/types";

export const useIsShowSavedSearchListPanel = () => {
    const dispatch = useDispatch();
    const { params } = useCurrentStateAndParams<SiAdvancedSearchPageParams>();

    useEffect(() => {
        if (params.isShowSavedSearchList) {
            dispatch(setIsOpenListPanel(true));
        }

        return () => {
            dispatch(setIsOpenListPanel(false));
        };
    }, [params.isShowSavedSearchList]);
};
